import React, { FunctionComponent } from "react";
import { Badge, Skeleton } from "@chakra-ui/react";
import { useIntl } from "react-intl";

interface IProps {
  state?: number;
}

const INVERTER_STATE = {
  NONE: 0,
  OK: 1,
  WARNING: 2,
  OFF: 3,
  ERROR: 4,
}

const InverterState: FunctionComponent<IProps> = ({ state }) => {
  const intl = useIntl();

  switch (state) {
    case INVERTER_STATE.NONE:
      return (
        <Badge colorScheme={"gray"}>
          {intl.formatMessage({
            id: "pv__inverter__state__none",
            defaultMessage: "-",
          })}
        </Badge>
      )
    case INVERTER_STATE.OK:
      return (
        <Badge variant="solid" colorScheme={"green"}>
          {intl.formatMessage({
            id: "pv__inverter__state__ok",
            defaultMessage: "OK",
          })}
        </Badge>
      )
    case INVERTER_STATE.WARNING:
      return (
        <Badge variant="solid" colorScheme={"yellow"}>
          {intl.formatMessage({
            id: "pv__inverter__state__warning",
            defaultMessage: "WARNING",
          })}
        </Badge>
      )
    case INVERTER_STATE.ERROR:
      return (
        <Badge variant="solid" colorScheme={"red"}>
          {intl.formatMessage({
            id: "pv__inverter__state__error",
            defaultMessage: "ERROR",
          })}
        </Badge>
      )
    case INVERTER_STATE.OFF:
      return (
        <Badge variant="solid" colorScheme={"blue"}>
          {intl.formatMessage({
            id: "pv__inverter__state__off",
            defaultMessage: "OFF",
          })}
        </Badge>
      )
    default:
      return (
        <Skeleton minW={5} w={10} h={3} />
      )
  }
};

export default InverterState;
